/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as ConnectDeskRouteImport } from './routes/connect-desk'
import { Route as DispatchRouteImport } from './routes/dispatch'
import { Route as FollowupsRouteImport } from './routes/followups'
import { Route as KnowledgeRouteImport } from './routes/knowledge'
import { Route as LedgerRouteImport } from './routes/ledger'
import { Route as LicencesRouteImport } from './routes/licences'
import { Route as MeRouteImport } from './routes/me'
import { Route as MyDayRouteImport } from './routes/my-day'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as PortalRouteRouteImport } from './routes/portal/route'
import { Route as ProfitRouteImport } from './routes/profit'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as SatisfactionRouteImport } from './routes/satisfaction'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SurveyRouteImport } from './routes/survey'
import { Route as AccountsIdRouteImport } from './routes/accounts.$id'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAiSpendRouteImport } from './routes/admin.ai-spend'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminBrandsRouteImport } from './routes/admin.brands'
import { Route as AdminContractorsRouteImport } from './routes/admin.contractors'
import { Route as AdminIntegrationsRouteImport } from './routes/admin.integrations'
import { Route as AdminPeopleRouteImport } from './routes/admin.people'
import { Route as AdminProjectTemplatesRouteImport } from './routes/admin.project-templates'
import { Route as AdminProjectsImportRouteImport } from './routes/admin.projects-import'
import { Route as AdminRatesRouteImport } from './routes/admin.rates'
import { Route as AdminRemovedRouteImport } from './routes/admin.removed'
import { Route as AdminRileyRouteImport } from './routes/admin.riley'
import { Route as AdminRileyFunctionsRouteImport } from './routes/admin.riley-functions'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminSnippetsRouteImport } from './routes/admin.snippets'
import { Route as AvailabilityTokenRouteImport } from './routes/availability.$token'
import { Route as CaseIdRouteImport } from './routes/case.$id'
import { Route as CasesAllRouteImport } from './routes/cases.all'
import { Route as CasesClosedRouteImport } from './routes/cases.closed'
import { Route as CasesOpenRouteImport } from './routes/cases.open'
import { Route as ContactsIdRouteImport } from './routes/contacts.$id'
import { Route as HelpIndexRouteImport } from './routes/help/index'
import { Route as LedgerPaymentOwedRouteImport } from './routes/ledger_.payment-owed'
import { Route as LedgerProcurementRouteImport } from './routes/ledger_.procurement'
import { Route as PickTokenRouteImport } from './routes/pick.$token'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as PortalLinkRouteImport } from './routes/portal/link'
import { Route as ProjectIdRouteImport } from './routes/project.$id'
import { Route as ProjectsLaneRouteImport } from './routes/projects.$lane'
import { Route as QueueIndexRouteImport } from './routes/queue.index'
import { Route as QueueLaneRouteImport } from './routes/queue.$lane'
import { Route as ReceiveOrderIdRouteImport } from './routes/receive.$orderId'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as ReportsReportIdRouteImport } from './routes/reports.$reportId'
import { Route as ReportsSettingsRouteImport } from './routes/reports.settings'
import { Route as VisitOutcomeVisitIdRouteImport } from './routes/visit-outcome.$visitId'
import { Route as WIndexRouteImport } from './routes/w.index'
import { Route as WTokenRouteImport } from './routes/w.$token'
import { Route as HelpSectionIndexRouteImport } from './routes/help/$section/index'
import { Route as HelpSectionSlugRouteImport } from './routes/help/$section/$slug'
import { Route as PortalJobsIdRouteImport } from './routes/portal/jobs.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectDeskRoute = ConnectDeskRouteImport.update({
  id: '/connect-desk',
  path: '/connect-desk',
  getParentRoute: () => rootRouteImport,
} as any)
const DispatchRoute = DispatchRouteImport.update({
  id: '/dispatch',
  path: '/dispatch',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowupsRoute = FollowupsRouteImport.update({
  id: '/followups',
  path: '/followups',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRoute = KnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const LedgerRoute = LedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => rootRouteImport,
} as any)
const LicencesRoute = LicencesRouteImport.update({
  id: '/licences',
  path: '/licences',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const MyDayRoute = MyDayRouteImport.update({
  id: '/my-day',
  path: '/my-day',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRouteRoute = PortalRouteRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfitRoute = ProfitRouteImport.update({
  id: '/profit',
  path: '/profit',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const SatisfactionRoute = SatisfactionRouteImport.update({
  id: '/satisfaction',
  path: '/satisfaction',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleRoute = ScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveyRoute = SurveyRouteImport.update({
  id: '/survey',
  path: '/survey',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsIdRoute = AccountsIdRouteImport.update({
  id: '/accounts/$id',
  path: '/accounts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAiSpendRoute = AdminAiSpendRouteImport.update({
  id: '/ai-spend',
  path: '/ai-spend',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBrandsRoute = AdminBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContractorsRoute = AdminContractorsRouteImport.update({
  id: '/contractors',
  path: '/contractors',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIntegrationsRoute = AdminIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPeopleRoute = AdminPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProjectTemplatesRoute = AdminProjectTemplatesRouteImport.update({
  id: '/project-templates',
  path: '/project-templates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProjectsImportRoute = AdminProjectsImportRouteImport.update({
  id: '/projects-import',
  path: '/projects-import',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRatesRoute = AdminRatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRemovedRoute = AdminRemovedRouteImport.update({
  id: '/removed',
  path: '/removed',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRileyRoute = AdminRileyRouteImport.update({
  id: '/riley',
  path: '/riley',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRileyFunctionsRoute = AdminRileyFunctionsRouteImport.update({
  id: '/riley-functions',
  path: '/riley-functions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSnippetsRoute = AdminSnippetsRouteImport.update({
  id: '/snippets',
  path: '/snippets',
  getParentRoute: () => AdminRoute,
} as any)
const AvailabilityTokenRoute = AvailabilityTokenRouteImport.update({
  id: '/availability/$token',
  path: '/availability/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CaseIdRoute = CaseIdRouteImport.update({
  id: '/case/$id',
  path: '/case/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesAllRoute = CasesAllRouteImport.update({
  id: '/cases/all',
  path: '/cases/all',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesClosedRoute = CasesClosedRouteImport.update({
  id: '/cases/closed',
  path: '/cases/closed',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesOpenRoute = CasesOpenRouteImport.update({
  id: '/cases/open',
  path: '/cases/open',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsIdRoute = ContactsIdRouteImport.update({
  id: '/contacts/$id',
  path: '/contacts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => rootRouteImport,
} as any)
const LedgerPaymentOwedRoute = LedgerPaymentOwedRouteImport.update({
  id: '/ledger_/payment-owed',
  path: '/ledger/payment-owed',
  getParentRoute: () => rootRouteImport,
} as any)
const LedgerProcurementRoute = LedgerProcurementRouteImport.update({
  id: '/ledger_/procurement',
  path: '/ledger/procurement',
  getParentRoute: () => rootRouteImport,
} as any)
const PickTokenRoute = PickTokenRouteImport.update({
  id: '/pick/$token',
  path: '/pick/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalLinkRoute = PortalLinkRouteImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => PortalRouteRoute,
} as any)
const ProjectIdRoute = ProjectIdRouteImport.update({
  id: '/project/$id',
  path: '/project/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsLaneRoute = ProjectsLaneRouteImport.update({
  id: '/$lane',
  path: '/$lane',
  getParentRoute: () => ProjectsRoute,
} as any)
const QueueIndexRoute = QueueIndexRouteImport.update({
  id: '/queue/',
  path: '/queue/',
  getParentRoute: () => rootRouteImport,
} as any)
const QueueLaneRoute = QueueLaneRouteImport.update({
  id: '/queue/$lane',
  path: '/queue/$lane',
  getParentRoute: () => rootRouteImport,
} as any)
const ReceiveOrderIdRoute = ReceiveOrderIdRouteImport.update({
  id: '/receive/$orderId',
  path: '/receive/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsReportIdRoute = ReportsReportIdRouteImport.update({
  id: '/reports/$reportId',
  path: '/reports/$reportId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsSettingsRoute = ReportsSettingsRouteImport.update({
  id: '/reports/settings',
  path: '/reports/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const VisitOutcomeVisitIdRoute = VisitOutcomeVisitIdRouteImport.update({
  id: '/visit-outcome/$visitId',
  path: '/visit-outcome/$visitId',
  getParentRoute: () => rootRouteImport,
} as any)
const WIndexRoute = WIndexRouteImport.update({
  id: '/w/',
  path: '/w/',
  getParentRoute: () => rootRouteImport,
} as any)
const WTokenRoute = WTokenRouteImport.update({
  id: '/w/$token',
  path: '/w/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpSectionIndexRoute = HelpSectionIndexRouteImport.update({
  id: '/help/$section/',
  path: '/help/$section/',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpSectionSlugRoute = HelpSectionSlugRouteImport.update({
  id: '/help/$section/$slug',
  path: '/help/$section/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalJobsIdRoute = PortalJobsIdRouteImport.update({
  id: '/jobs/$id',
  path: '/jobs/$id',
  getParentRoute: () => PortalRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/portal': typeof PortalRouteRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/billing': typeof BillingRoute
  '/connect-desk': typeof ConnectDeskRoute
  '/dispatch': typeof DispatchRoute
  '/followups': typeof FollowupsRoute
  '/knowledge': typeof KnowledgeRoute
  '/ledger': typeof LedgerRoute
  '/licences': typeof LicencesRoute
  '/me': typeof MeRoute
  '/my-day': typeof MyDayRoute
  '/notifications': typeof NotificationsRoute
  '/profit': typeof ProfitRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/satisfaction': typeof SatisfactionRoute
  '/schedule': typeof ScheduleRoute
  '/signin': typeof SigninRoute
  '/survey': typeof SurveyRoute
  '/accounts/$id': typeof AccountsIdRoute
  '/admin/ai-spend': typeof AdminAiSpendRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/brands': typeof AdminBrandsRoute
  '/admin/contractors': typeof AdminContractorsRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/people': typeof AdminPeopleRoute
  '/admin/project-templates': typeof AdminProjectTemplatesRoute
  '/admin/projects-import': typeof AdminProjectsImportRoute
  '/admin/rates': typeof AdminRatesRoute
  '/admin/removed': typeof AdminRemovedRoute
  '/admin/riley': typeof AdminRileyRoute
  '/admin/riley-functions': typeof AdminRileyFunctionsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/snippets': typeof AdminSnippetsRoute
  '/availability/$token': typeof AvailabilityTokenRoute
  '/case/$id': typeof CaseIdRoute
  '/cases/all': typeof CasesAllRoute
  '/cases/closed': typeof CasesClosedRoute
  '/cases/open': typeof CasesOpenRoute
  '/contacts/$id': typeof ContactsIdRoute
  '/ledger/payment-owed': typeof LedgerPaymentOwedRoute
  '/ledger/procurement': typeof LedgerProcurementRoute
  '/pick/$token': typeof PickTokenRoute
  '/portal/link': typeof PortalLinkRoute
  '/project/$id': typeof ProjectIdRoute
  '/projects/$lane': typeof ProjectsLaneRoute
  '/queue/$lane': typeof QueueLaneRoute
  '/receive/$orderId': typeof ReceiveOrderIdRoute
  '/reports/$reportId': typeof ReportsReportIdRoute
  '/reports/settings': typeof ReportsSettingsRoute
  '/visit-outcome/$visitId': typeof VisitOutcomeVisitIdRoute
  '/w/$token': typeof WTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/help/': typeof HelpIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/queue/': typeof QueueIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/w/': typeof WIndexRoute
  '/help/$section/$slug': typeof HelpSectionSlugRoute
  '/portal/jobs/$id': typeof PortalJobsIdRoute
  '/help/$section/': typeof HelpSectionIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/connect-desk': typeof ConnectDeskRoute
  '/dispatch': typeof DispatchRoute
  '/followups': typeof FollowupsRoute
  '/knowledge': typeof KnowledgeRoute
  '/ledger': typeof LedgerRoute
  '/licences': typeof LicencesRoute
  '/me': typeof MeRoute
  '/my-day': typeof MyDayRoute
  '/notifications': typeof NotificationsRoute
  '/profit': typeof ProfitRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/satisfaction': typeof SatisfactionRoute
  '/schedule': typeof ScheduleRoute
  '/signin': typeof SigninRoute
  '/survey': typeof SurveyRoute
  '/accounts/$id': typeof AccountsIdRoute
  '/admin/ai-spend': typeof AdminAiSpendRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/brands': typeof AdminBrandsRoute
  '/admin/contractors': typeof AdminContractorsRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/people': typeof AdminPeopleRoute
  '/admin/project-templates': typeof AdminProjectTemplatesRoute
  '/admin/projects-import': typeof AdminProjectsImportRoute
  '/admin/rates': typeof AdminRatesRoute
  '/admin/removed': typeof AdminRemovedRoute
  '/admin/riley': typeof AdminRileyRoute
  '/admin/riley-functions': typeof AdminRileyFunctionsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/snippets': typeof AdminSnippetsRoute
  '/availability/$token': typeof AvailabilityTokenRoute
  '/case/$id': typeof CaseIdRoute
  '/cases/all': typeof CasesAllRoute
  '/cases/closed': typeof CasesClosedRoute
  '/cases/open': typeof CasesOpenRoute
  '/contacts/$id': typeof ContactsIdRoute
  '/ledger/payment-owed': typeof LedgerPaymentOwedRoute
  '/ledger/procurement': typeof LedgerProcurementRoute
  '/pick/$token': typeof PickTokenRoute
  '/portal/link': typeof PortalLinkRoute
  '/project/$id': typeof ProjectIdRoute
  '/projects/$lane': typeof ProjectsLaneRoute
  '/queue/$lane': typeof QueueLaneRoute
  '/receive/$orderId': typeof ReceiveOrderIdRoute
  '/reports/$reportId': typeof ReportsReportIdRoute
  '/reports/settings': typeof ReportsSettingsRoute
  '/visit-outcome/$visitId': typeof VisitOutcomeVisitIdRoute
  '/w/$token': typeof WTokenRoute
  '/admin': typeof AdminIndexRoute
  '/help': typeof HelpIndexRoute
  '/portal': typeof PortalIndexRoute
  '/queue': typeof QueueIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/w': typeof WIndexRoute
  '/help/$section/$slug': typeof HelpSectionSlugRoute
  '/portal/jobs/$id': typeof PortalJobsIdRoute
  '/help/$section': typeof HelpSectionIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/portal': typeof PortalRouteRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/billing': typeof BillingRoute
  '/connect-desk': typeof ConnectDeskRoute
  '/dispatch': typeof DispatchRoute
  '/followups': typeof FollowupsRoute
  '/knowledge': typeof KnowledgeRoute
  '/ledger': typeof LedgerRoute
  '/licences': typeof LicencesRoute
  '/me': typeof MeRoute
  '/my-day': typeof MyDayRoute
  '/notifications': typeof NotificationsRoute
  '/profit': typeof ProfitRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/satisfaction': typeof SatisfactionRoute
  '/schedule': typeof ScheduleRoute
  '/signin': typeof SigninRoute
  '/survey': typeof SurveyRoute
  '/accounts/$id': typeof AccountsIdRoute
  '/admin/ai-spend': typeof AdminAiSpendRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/brands': typeof AdminBrandsRoute
  '/admin/contractors': typeof AdminContractorsRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/people': typeof AdminPeopleRoute
  '/admin/project-templates': typeof AdminProjectTemplatesRoute
  '/admin/projects-import': typeof AdminProjectsImportRoute
  '/admin/rates': typeof AdminRatesRoute
  '/admin/removed': typeof AdminRemovedRoute
  '/admin/riley': typeof AdminRileyRoute
  '/admin/riley-functions': typeof AdminRileyFunctionsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/snippets': typeof AdminSnippetsRoute
  '/availability/$token': typeof AvailabilityTokenRoute
  '/case/$id': typeof CaseIdRoute
  '/cases/all': typeof CasesAllRoute
  '/cases/closed': typeof CasesClosedRoute
  '/cases/open': typeof CasesOpenRoute
  '/contacts/$id': typeof ContactsIdRoute
  '/ledger_/payment-owed': typeof LedgerPaymentOwedRoute
  '/ledger_/procurement': typeof LedgerProcurementRoute
  '/pick/$token': typeof PickTokenRoute
  '/portal/link': typeof PortalLinkRoute
  '/project/$id': typeof ProjectIdRoute
  '/projects/$lane': typeof ProjectsLaneRoute
  '/queue/$lane': typeof QueueLaneRoute
  '/receive/$orderId': typeof ReceiveOrderIdRoute
  '/reports/$reportId': typeof ReportsReportIdRoute
  '/reports/settings': typeof ReportsSettingsRoute
  '/visit-outcome/$visitId': typeof VisitOutcomeVisitIdRoute
  '/w/$token': typeof WTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/help/': typeof HelpIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/queue/': typeof QueueIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/w/': typeof WIndexRoute
  '/help/$section/$slug': typeof HelpSectionSlugRoute
  '/portal/jobs/$id': typeof PortalJobsIdRoute
  '/help/$section/': typeof HelpSectionIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/portal'
    | '/admin'
    | '/billing'
    | '/connect-desk'
    | '/dispatch'
    | '/followups'
    | '/knowledge'
    | '/ledger'
    | '/licences'
    | '/me'
    | '/my-day'
    | '/notifications'
    | '/profit'
    | '/projects'
    | '/satisfaction'
    | '/schedule'
    | '/signin'
    | '/survey'
    | '/accounts/$id'
    | '/admin/ai-spend'
    | '/admin/audit'
    | '/admin/brands'
    | '/admin/contractors'
    | '/admin/integrations'
    | '/admin/people'
    | '/admin/project-templates'
    | '/admin/projects-import'
    | '/admin/rates'
    | '/admin/removed'
    | '/admin/riley'
    | '/admin/riley-functions'
    | '/admin/settings'
    | '/admin/snippets'
    | '/availability/$token'
    | '/case/$id'
    | '/cases/all'
    | '/cases/closed'
    | '/cases/open'
    | '/contacts/$id'
    | '/ledger/payment-owed'
    | '/ledger/procurement'
    | '/pick/$token'
    | '/portal/link'
    | '/project/$id'
    | '/projects/$lane'
    | '/queue/$lane'
    | '/receive/$orderId'
    | '/reports/$reportId'
    | '/reports/settings'
    | '/visit-outcome/$visitId'
    | '/w/$token'
    | '/admin/'
    | '/help/'
    | '/portal/'
    | '/queue/'
    | '/reports/'
    | '/w/'
    | '/help/$section/$slug'
    | '/portal/jobs/$id'
    | '/help/$section/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/billing'
    | '/connect-desk'
    | '/dispatch'
    | '/followups'
    | '/knowledge'
    | '/ledger'
    | '/licences'
    | '/me'
    | '/my-day'
    | '/notifications'
    | '/profit'
    | '/projects'
    | '/satisfaction'
    | '/schedule'
    | '/signin'
    | '/survey'
    | '/accounts/$id'
    | '/admin/ai-spend'
    | '/admin/audit'
    | '/admin/brands'
    | '/admin/contractors'
    | '/admin/integrations'
    | '/admin/people'
    | '/admin/project-templates'
    | '/admin/projects-import'
    | '/admin/rates'
    | '/admin/removed'
    | '/admin/riley'
    | '/admin/riley-functions'
    | '/admin/settings'
    | '/admin/snippets'
    | '/availability/$token'
    | '/case/$id'
    | '/cases/all'
    | '/cases/closed'
    | '/cases/open'
    | '/contacts/$id'
    | '/ledger/payment-owed'
    | '/ledger/procurement'
    | '/pick/$token'
    | '/portal/link'
    | '/project/$id'
    | '/projects/$lane'
    | '/queue/$lane'
    | '/receive/$orderId'
    | '/reports/$reportId'
    | '/reports/settings'
    | '/visit-outcome/$visitId'
    | '/w/$token'
    | '/admin'
    | '/help'
    | '/portal'
    | '/queue'
    | '/reports'
    | '/w'
    | '/help/$section/$slug'
    | '/portal/jobs/$id'
    | '/help/$section'
  id:
    | '__root__'
    | '/'
    | '/portal'
    | '/admin'
    | '/billing'
    | '/connect-desk'
    | '/dispatch'
    | '/followups'
    | '/knowledge'
    | '/ledger'
    | '/licences'
    | '/me'
    | '/my-day'
    | '/notifications'
    | '/profit'
    | '/projects'
    | '/satisfaction'
    | '/schedule'
    | '/signin'
    | '/survey'
    | '/accounts/$id'
    | '/admin/ai-spend'
    | '/admin/audit'
    | '/admin/brands'
    | '/admin/contractors'
    | '/admin/integrations'
    | '/admin/people'
    | '/admin/project-templates'
    | '/admin/projects-import'
    | '/admin/rates'
    | '/admin/removed'
    | '/admin/riley'
    | '/admin/riley-functions'
    | '/admin/settings'
    | '/admin/snippets'
    | '/availability/$token'
    | '/case/$id'
    | '/cases/all'
    | '/cases/closed'
    | '/cases/open'
    | '/contacts/$id'
    | '/ledger_/payment-owed'
    | '/ledger_/procurement'
    | '/pick/$token'
    | '/portal/link'
    | '/project/$id'
    | '/projects/$lane'
    | '/queue/$lane'
    | '/receive/$orderId'
    | '/reports/$reportId'
    | '/reports/settings'
    | '/visit-outcome/$visitId'
    | '/w/$token'
    | '/admin/'
    | '/help/'
    | '/portal/'
    | '/queue/'
    | '/reports/'
    | '/w/'
    | '/help/$section/$slug'
    | '/portal/jobs/$id'
    | '/help/$section/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PortalRouteRoute: typeof PortalRouteRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  BillingRoute: typeof BillingRoute
  ConnectDeskRoute: typeof ConnectDeskRoute
  DispatchRoute: typeof DispatchRoute
  FollowupsRoute: typeof FollowupsRoute
  KnowledgeRoute: typeof KnowledgeRoute
  LedgerRoute: typeof LedgerRoute
  LicencesRoute: typeof LicencesRoute
  MeRoute: typeof MeRoute
  MyDayRoute: typeof MyDayRoute
  NotificationsRoute: typeof NotificationsRoute
  ProfitRoute: typeof ProfitRoute
  ProjectsRoute: typeof ProjectsRouteWithChildren
  SatisfactionRoute: typeof SatisfactionRoute
  ScheduleRoute: typeof ScheduleRoute
  SigninRoute: typeof SigninRoute
  SurveyRoute: typeof SurveyRoute
  AccountsIdRoute: typeof AccountsIdRoute
  AvailabilityTokenRoute: typeof AvailabilityTokenRoute
  CaseIdRoute: typeof CaseIdRoute
  CasesAllRoute: typeof CasesAllRoute
  CasesClosedRoute: typeof CasesClosedRoute
  CasesOpenRoute: typeof CasesOpenRoute
  ContactsIdRoute: typeof ContactsIdRoute
  LedgerPaymentOwedRoute: typeof LedgerPaymentOwedRoute
  LedgerProcurementRoute: typeof LedgerProcurementRoute
  PickTokenRoute: typeof PickTokenRoute
  ProjectIdRoute: typeof ProjectIdRoute
  QueueLaneRoute: typeof QueueLaneRoute
  ReceiveOrderIdRoute: typeof ReceiveOrderIdRoute
  ReportsReportIdRoute: typeof ReportsReportIdRoute
  ReportsSettingsRoute: typeof ReportsSettingsRoute
  VisitOutcomeVisitIdRoute: typeof VisitOutcomeVisitIdRoute
  WTokenRoute: typeof WTokenRoute
  HelpIndexRoute: typeof HelpIndexRoute
  QueueIndexRoute: typeof QueueIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  WIndexRoute: typeof WIndexRoute
  HelpSectionSlugRoute: typeof HelpSectionSlugRoute
  HelpSectionIndexRoute: typeof HelpSectionIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect-desk': {
      id: '/connect-desk'
      path: '/connect-desk'
      fullPath: '/connect-desk'
      preLoaderRoute: typeof ConnectDeskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dispatch': {
      id: '/dispatch'
      path: '/dispatch'
      fullPath: '/dispatch'
      preLoaderRoute: typeof DispatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/followups': {
      id: '/followups'
      path: '/followups'
      fullPath: '/followups'
      preLoaderRoute: typeof FollowupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ledger': {
      id: '/ledger'
      path: '/ledger'
      fullPath: '/ledger'
      preLoaderRoute: typeof LedgerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/licences': {
      id: '/licences'
      path: '/licences'
      fullPath: '/licences'
      preLoaderRoute: typeof LicencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-day': {
      id: '/my-day'
      path: '/my-day'
      fullPath: '/my-day'
      preLoaderRoute: typeof MyDayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profit': {
      id: '/profit'
      path: '/profit'
      fullPath: '/profit'
      preLoaderRoute: typeof ProfitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/satisfaction': {
      id: '/satisfaction'
      path: '/satisfaction'
      fullPath: '/satisfaction'
      preLoaderRoute: typeof SatisfactionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule': {
      id: '/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof ScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/survey': {
      id: '/survey'
      path: '/survey'
      fullPath: '/survey'
      preLoaderRoute: typeof SurveyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts/$id': {
      id: '/accounts/$id'
      path: '/accounts/$id'
      fullPath: '/accounts/$id'
      preLoaderRoute: typeof AccountsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ai-spend': {
      id: '/admin/ai-spend'
      path: '/ai-spend'
      fullPath: '/admin/ai-spend'
      preLoaderRoute: typeof AdminAiSpendRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/brands': {
      id: '/admin/brands'
      path: '/brands'
      fullPath: '/admin/brands'
      preLoaderRoute: typeof AdminBrandsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/contractors': {
      id: '/admin/contractors'
      path: '/contractors'
      fullPath: '/admin/contractors'
      preLoaderRoute: typeof AdminContractorsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/integrations': {
      id: '/admin/integrations'
      path: '/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AdminIntegrationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/people': {
      id: '/admin/people'
      path: '/people'
      fullPath: '/admin/people'
      preLoaderRoute: typeof AdminPeopleRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/project-templates': {
      id: '/admin/project-templates'
      path: '/project-templates'
      fullPath: '/admin/project-templates'
      preLoaderRoute: typeof AdminProjectTemplatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/projects-import': {
      id: '/admin/projects-import'
      path: '/projects-import'
      fullPath: '/admin/projects-import'
      preLoaderRoute: typeof AdminProjectsImportRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/rates': {
      id: '/admin/rates'
      path: '/rates'
      fullPath: '/admin/rates'
      preLoaderRoute: typeof AdminRatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/removed': {
      id: '/admin/removed'
      path: '/removed'
      fullPath: '/admin/removed'
      preLoaderRoute: typeof AdminRemovedRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/riley': {
      id: '/admin/riley'
      path: '/riley'
      fullPath: '/admin/riley'
      preLoaderRoute: typeof AdminRileyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/riley-functions': {
      id: '/admin/riley-functions'
      path: '/riley-functions'
      fullPath: '/admin/riley-functions'
      preLoaderRoute: typeof AdminRileyFunctionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/snippets': {
      id: '/admin/snippets'
      path: '/snippets'
      fullPath: '/admin/snippets'
      preLoaderRoute: typeof AdminSnippetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/availability/$token': {
      id: '/availability/$token'
      path: '/availability/$token'
      fullPath: '/availability/$token'
      preLoaderRoute: typeof AvailabilityTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/case/$id': {
      id: '/case/$id'
      path: '/case/$id'
      fullPath: '/case/$id'
      preLoaderRoute: typeof CaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases/all': {
      id: '/cases/all'
      path: '/cases/all'
      fullPath: '/cases/all'
      preLoaderRoute: typeof CasesAllRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases/closed': {
      id: '/cases/closed'
      path: '/cases/closed'
      fullPath: '/cases/closed'
      preLoaderRoute: typeof CasesClosedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases/open': {
      id: '/cases/open'
      path: '/cases/open'
      fullPath: '/cases/open'
      preLoaderRoute: typeof CasesOpenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/$id': {
      id: '/contacts/$id'
      path: '/contacts/$id'
      fullPath: '/contacts/$id'
      preLoaderRoute: typeof ContactsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/': {
      id: '/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ledger_/payment-owed': {
      id: '/ledger_/payment-owed'
      path: '/ledger/payment-owed'
      fullPath: '/ledger/payment-owed'
      preLoaderRoute: typeof LedgerPaymentOwedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ledger_/procurement': {
      id: '/ledger_/procurement'
      path: '/ledger/procurement'
      fullPath: '/ledger/procurement'
      preLoaderRoute: typeof LedgerProcurementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pick/$token': {
      id: '/pick/$token'
      path: '/pick/$token'
      fullPath: '/pick/$token'
      preLoaderRoute: typeof PickTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/link': {
      id: '/portal/link'
      path: '/link'
      fullPath: '/portal/link'
      preLoaderRoute: typeof PortalLinkRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/project/$id': {
      id: '/project/$id'
      path: '/project/$id'
      fullPath: '/project/$id'
      preLoaderRoute: typeof ProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$lane': {
      id: '/projects/$lane'
      path: '/$lane'
      fullPath: '/projects/$lane'
      preLoaderRoute: typeof ProjectsLaneRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/queue/': {
      id: '/queue/'
      path: '/queue'
      fullPath: '/queue/'
      preLoaderRoute: typeof QueueIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/queue/$lane': {
      id: '/queue/$lane'
      path: '/queue/$lane'
      fullPath: '/queue/$lane'
      preLoaderRoute: typeof QueueLaneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/receive/$orderId': {
      id: '/receive/$orderId'
      path: '/receive/$orderId'
      fullPath: '/receive/$orderId'
      preLoaderRoute: typeof ReceiveOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/$reportId': {
      id: '/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof ReportsReportIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/settings': {
      id: '/reports/settings'
      path: '/reports/settings'
      fullPath: '/reports/settings'
      preLoaderRoute: typeof ReportsSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/visit-outcome/$visitId': {
      id: '/visit-outcome/$visitId'
      path: '/visit-outcome/$visitId'
      fullPath: '/visit-outcome/$visitId'
      preLoaderRoute: typeof VisitOutcomeVisitIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/': {
      id: '/w/'
      path: '/w'
      fullPath: '/w/'
      preLoaderRoute: typeof WIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/$token': {
      id: '/w/$token'
      path: '/w/$token'
      fullPath: '/w/$token'
      preLoaderRoute: typeof WTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/$section/': {
      id: '/help/$section/'
      path: '/help/$section'
      fullPath: '/help/$section/'
      preLoaderRoute: typeof HelpSectionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/$section/$slug': {
      id: '/help/$section/$slug'
      path: '/help/$section/$slug'
      fullPath: '/help/$section/$slug'
      preLoaderRoute: typeof HelpSectionSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/jobs/$id': {
      id: '/portal/jobs/$id'
      path: '/jobs/$id'
      fullPath: '/portal/jobs/$id'
      preLoaderRoute: typeof PortalJobsIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
  }
}

interface PortalRouteRouteChildren {
  PortalLinkRoute: typeof PortalLinkRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PortalJobsIdRoute: typeof PortalJobsIdRoute
}

const PortalRouteRouteChildren: PortalRouteRouteChildren = {
  PortalLinkRoute: PortalLinkRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalJobsIdRoute: PortalJobsIdRoute,
}

const PortalRouteRouteWithChildren = PortalRouteRoute._addFileChildren(
  PortalRouteRouteChildren,
)

interface AdminRouteChildren {
  AdminAiSpendRoute: typeof AdminAiSpendRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminBrandsRoute: typeof AdminBrandsRoute
  AdminContractorsRoute: typeof AdminContractorsRoute
  AdminIntegrationsRoute: typeof AdminIntegrationsRoute
  AdminPeopleRoute: typeof AdminPeopleRoute
  AdminProjectTemplatesRoute: typeof AdminProjectTemplatesRoute
  AdminProjectsImportRoute: typeof AdminProjectsImportRoute
  AdminRatesRoute: typeof AdminRatesRoute
  AdminRemovedRoute: typeof AdminRemovedRoute
  AdminRileyRoute: typeof AdminRileyRoute
  AdminRileyFunctionsRoute: typeof AdminRileyFunctionsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminSnippetsRoute: typeof AdminSnippetsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAiSpendRoute: AdminAiSpendRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminBrandsRoute: AdminBrandsRoute,
  AdminContractorsRoute: AdminContractorsRoute,
  AdminIntegrationsRoute: AdminIntegrationsRoute,
  AdminPeopleRoute: AdminPeopleRoute,
  AdminProjectTemplatesRoute: AdminProjectTemplatesRoute,
  AdminProjectsImportRoute: AdminProjectsImportRoute,
  AdminRatesRoute: AdminRatesRoute,
  AdminRemovedRoute: AdminRemovedRoute,
  AdminRileyRoute: AdminRileyRoute,
  AdminRileyFunctionsRoute: AdminRileyFunctionsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminSnippetsRoute: AdminSnippetsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ProjectsRouteChildren {
  ProjectsLaneRoute: typeof ProjectsLaneRoute
}

const ProjectsRouteChildren: ProjectsRouteChildren = {
  ProjectsLaneRoute: ProjectsLaneRoute,
}

const ProjectsRouteWithChildren = ProjectsRoute._addFileChildren(
  ProjectsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PortalRouteRoute: PortalRouteRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  BillingRoute: BillingRoute,
  ConnectDeskRoute: ConnectDeskRoute,
  DispatchRoute: DispatchRoute,
  FollowupsRoute: FollowupsRoute,
  KnowledgeRoute: KnowledgeRoute,
  LedgerRoute: LedgerRoute,
  LicencesRoute: LicencesRoute,
  MeRoute: MeRoute,
  MyDayRoute: MyDayRoute,
  NotificationsRoute: NotificationsRoute,
  ProfitRoute: ProfitRoute,
  ProjectsRoute: ProjectsRouteWithChildren,
  SatisfactionRoute: SatisfactionRoute,
  ScheduleRoute: ScheduleRoute,
  SigninRoute: SigninRoute,
  SurveyRoute: SurveyRoute,
  AccountsIdRoute: AccountsIdRoute,
  AvailabilityTokenRoute: AvailabilityTokenRoute,
  CaseIdRoute: CaseIdRoute,
  CasesAllRoute: CasesAllRoute,
  CasesClosedRoute: CasesClosedRoute,
  CasesOpenRoute: CasesOpenRoute,
  ContactsIdRoute: ContactsIdRoute,
  LedgerPaymentOwedRoute: LedgerPaymentOwedRoute,
  LedgerProcurementRoute: LedgerProcurementRoute,
  PickTokenRoute: PickTokenRoute,
  ProjectIdRoute: ProjectIdRoute,
  QueueLaneRoute: QueueLaneRoute,
  ReceiveOrderIdRoute: ReceiveOrderIdRoute,
  ReportsReportIdRoute: ReportsReportIdRoute,
  ReportsSettingsRoute: ReportsSettingsRoute,
  VisitOutcomeVisitIdRoute: VisitOutcomeVisitIdRoute,
  WTokenRoute: WTokenRoute,
  HelpIndexRoute: HelpIndexRoute,
  QueueIndexRoute: QueueIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  WIndexRoute: WIndexRoute,
  HelpSectionSlugRoute: HelpSectionSlugRoute,
  HelpSectionIndexRoute: HelpSectionIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
